<div class="interest-field-card" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="interest-field-card__badge"><brt-item-tag [title]="field.tag" [clickable]="false"></brt-item-tag></div>


  <div class="interest-field-card__name" [innerHTML]="title" *ngIf="!addRoughHeadline"></div>
  <div class="interest-field-card__name" brtRoughText [color]="StoryTheme.PETROL" [type]="'highlight'" [state]="'run'" [selector]="'em'" [innerHTML]="title" *ngIf="addRoughHeadline"></div>

  <div class="interest-field-card__animation">
    <div class="interest-field-card__animation-container" *ngIf="hasAnimation; else svgIcon" [attr.aria-label]="'ACCESSIBILITY.INTEREST_FIELDS.ID_' + field.id + '.LOTTIE_ALT' | translate">
      <brt-lottie [lottieOptions]="{loop: true, autoplay: false, path: field.lottieSrc}" [frameRate]="5" (instanceCreated)="onLottieAnimatedCreated($event)" aria-hidden="true"></brt-lottie>
    </div>

    <ng-template #svgIcon>
      <img [src]="field.lottieSrc" [alt]="field.name" />
    </ng-template>
  </div>


  <div class="interest-field-card__filter-links">
    <a [routerLink]="schoolCompanyFilterLink" [fragment]="schoolCompanyFilterLinkFragment" class="interest-field-card__filter-link animline animline--black">{{field.companiesNumber}} Anbieter anzeigen</a>
    <a [routerLink]="professionFilterLink" [fragment]="professionFilterLinkFragment" class="interest-field-card__filter-link animline animline--black">{{field.professionsNumber}} Berufe anzeigen</a>
  </div>
</div>
